// Rich-text helpers for product descriptions. The editor produces a small,
// standard HTML subset (paragraphs, bold, bullet/numbered lists); these keep it
// safe and tidy for both saving and rendering on the customer storefront.

const ALLOWED_TAGS = new Set(['P', 'DIV', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI']);
const DROP_TAGS = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'LINK', 'META', 'HEAD']);

const ELEMENT = 1;
const COMMENT = 8;

// Whitelist-sanitise a fragment of HTML: keep only safe formatting tags, drop
// scripts/styles, unwrap anything else (keeping its text), and strip every
// attribute (so no inline styles, event handlers, hrefs or srcs survive).
export const sanitizeRichText = (html) => {
  if (!html) return '';
  if (typeof document === 'undefined') return String(html);
  const tpl = document.createElement('template');
  tpl.innerHTML = String(html);

  const walk = (parent) => {
    Array.from(parent.childNodes).forEach((node) => {
      if (node.nodeType === COMMENT) { node.remove(); return; }
      if (node.nodeType !== ELEMENT) return; // text nodes pass through
      const tag = node.tagName;
      if (DROP_TAGS.has(tag)) { node.remove(); return; }
      if (!ALLOWED_TAGS.has(tag)) {
        // Unknown tag (e.g. a styled <span>): clean its descendants, then
        // unwrap it so its text content is preserved.
        walk(node);
        while (node.firstChild) parent.insertBefore(node.firstChild, node);
        parent.removeChild(node);
        return;
      }
      Array.from(node.attributes).forEach((a) => node.removeAttribute(a.name));
      walk(node);
    });
  };
  walk(tpl.content);
  return tpl.innerHTML;
};

// True when the rich-text value has no visible content (empty, or only an empty
// paragraph / <br> that the editor leaves behind).
export const isRichEmpty = (html) => {
  if (!html) return true;
  const text = String(html).replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').replace(/ /g, ' ').trim();
  return text.length === 0;
};
